import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { PulsMeta } from "@/types";

// #335 (UC-5): die Admin-Meta zum Puls eines Agenten (`GET /agents/:id/puls/meta`).
//
// ⚠ Es gibt bewusst KEINE Query auf den INHALT — die Route liefert keinen (Konzept
// Entscheidung 12). Wer den Puls sehen will, ist der Nutzer, in seiner eigenen App.
export function useAgentPulsMeta(agentId?: string): UseQueryResult<PulsMeta> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.subResource("agents", agentId ?? "-", "puls-meta"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<PulsMeta>(`/agents/${agentId}/puls/meta`);
    },
    enabled: !!session && !!agentId,
  });
}
